export const orange = {
  100: 'var(--bfc-v2-color-orange-100, #fff3eb)',
  200: 'var(--bfc-v2-color-orange-200, #fedec8)',
  300: 'var(--bfc-v2-color-orange-300, #fec195)',
  400: 'var(--bfc-v2-color-orange-400, #fea362)',
  500: 'var(--bfc-v2-color-orange-500, #f38a3f)',
  600: 'var(--bfc-v2-color-orange-600, #e56910)',
  700: 'var(--bfc-v2-color-orange-700, #c25100)',
  800: 'var(--bfc-v2-color-orange-800, #a54800)',
  900: 'var(--bfc-v2-color-orange-900, #702e00)',
  1000: 'var(--bfc-v2-color-orange-1000, #38291e)',
  DEFAULT: 'var(--bfc-v2-color-orange-700, #c25100)', // 700
};
